export default {
  account: '/images/account.svg',

  'analytics-icon': '/images/analytics-icon.svg',

  'no-data': '/images/no-data.svg',

  merchant: '/images/admin-merchant.svg',

  'active-dotted-menu': '/images/active_triple_dots.svg',

  apay: '/images/apay.svg',

  award: '/images/award.svg',

  arrowLeft: '/images/arrow-left.svg',
  transactionIcon: '/images/transaction-icon.svg',
  transactionCount: '/images/transaction-count.svg',
  lastSettlement: '/images/last-settlement.svg',

  'customize-icon': '/images/cutomize-columns.svg',

  'visa-icon1': '/images/visa-icon.png',
  'arrow-right-disabled': '/images/arror-right-disabled.png',
  'arrow-left-disabled': '/images/arrow-left-disabled.png',
  'arrow-right-enabled': '/images/arrow-right-enabled.png',
  'arrow-left-enabled': '/images/arrow-left-enabled.png',

  'product-plural-gateway': '/images/product-plural-gateway.svg',
  'product-plural-payouts': '/images/product-plural-payouts.svg',
  'product-plural-tokenizer': '/images/product-plural-tokenizer.svg',
  'learn-more': '/images/learn-more.svg',

  'back-arrow': '/images/back-arrow.svg',

  'card-icon': '/images/card-icon.svg',

  'card-img': '/images/card-img.svg',

  'check-sucees': '/images/check-sucees.svg',

  checkCirle: '/images/checkCircle.svg',

  watchVideo: '/images/watch-video.svg',

  upload: '/images/upload.svg',

  envelope: '/images/envelope.svg',

  checked: '/images/checked.svg',

  'checkout-logo': '/images/checkout-default-logo.svg',

  'close-eye': '/images/close-eye.svg',

  'preview-eye': '/images/preview-eye.svg',

  'close-icon': '/images/close-icon.svg',

  'close-blue-icon': '/images/close-blue-icon.svg',

  'welcome-close-icon': '/images/welcome-close-icon.svg',

  'welcome-icon': '/images/welcome-icon.svg',

  'left-arrow-dark': '/images/left-arrow-dark.svg',

  'attach-icon': '/images/attach-icon.svg',

  'arrow-circle-right': '/images/arrow-circle-right.svg',

  'account-circle': '/images/account-circle.svg',

  'add-director': '/images/add-director.svg',

  'remove-director': '/images/remove-director.svg',

  'support-request': '/images/support-request.svg',

  'file-icon': '/images/file-icon.svg',

  'file-remove': '/images/file-remove.svg',

  'success-icon': '/images/success-icon.svg',

  'kyc-submitted': '/images/kyc-submitted.svg',

  'approved-icon': '/images/approved-icon.svg',

  'ticket-success': '/images/ticket-success.svg',

  'close-model': '/images/close-model.svg',

  'collapse-icon': '/images/collapse-icon.svg',

  'colour-bg': '/images/colour-bg.svg',

  cross: '/images/cross.svg',

  'dotted-menu': '/images/dotted-menu.svg',

  'down-arrow': '/images/down-arrow.svg',

  'down-arrow-blue': '/images/down-arrow-blue.svg',

  'download-icon': '/images/download-icon.svg',
  'citi-download-icon': '/images/citi-download-icon.svg',

  edit_icon: '/images/edit_icon.svg',

  'email-icon': '/images/email-icon.svg',

  'error-close': '/images/error-close.svg',

  'filter-close': '/images/filter-close.svg',

  'filter-icon': '/images/filter-icon.svg',
  'citi-filter-icon': '/images/citi-filter-icon.svg',

  'grid-icon': '/images/grid-icon.svg',
  'citi-grid-icon': '/images/citi-grid-icon.svg',

  'grid-xmark': '/images/grid-xmark.svg',

  hdfc: '/images/hdfc.svg',

  'help-icon': '/images/help-icon.svg',

  indeterminate: '/images/indeterminate.svg',

  'info-icon': '/images/info-icon.svg',

  'links-icon': '/images/links-icon.svg',

  loader: '/images/loader.gif',

  logo: '/images/plural-Logo.svg',

  'next-icon': '/images/next-icon.svg',

  'open-eye': '/images/open-eye.svg',

  'open-new-tab-blue': '/images/open-new-tab-blue.svg',

  'open-new-tab': '/images/open-new-tab.svg',

  'overview-icon': '/images/overview-icon.svg',

  'password-icon': '/images/password-icon.svg',

  'payments-icon': '/images/payments-icon.svg',

  'payment-img': '/images/payment-img.png',

  'payment-pages-icon': '/images/payment-pages-icon.svg',

  phone: '/images/phone.svg',

  'refresh-icon': '/images/refresh-icon.svg',

  'partner-refresh-icon': '/images/refresh-icon2.svg',

  'refunds-icon': '/images/refunds-icon.svg',

  'right-arrow-blue': '/images/right-arrow-blue.svg',

  'right-arrow': '/images/right-arrow.svg',

  'left-arrow': '/images/left-arrow.svg',

  'routing-icon': '/images/routing-icon.svg',

  'search-icon': '/images/search-icon.svg',

  'settings-icon': '/images/settings-icon.svg',

  'settlements-icon': '/images/settlements-icon.svg',

  'subscription-icon': '/images/subscription-icon.svg',

  unchecked: '/images/unchecked.svg',

  'up-arrow': '/images/up-arrow.svg',

  'validate-icon': '/images/validate-icon.svg',

  'warning-icon': '/images/warning-icon.svg',
  'warning-icon-circle': '/images/warning-icon-circle.svg',
  'warning-icon-circle-orange': '/images/warning-circle-orange.svg',
  'bulk-logo': '/images/bulk-logo.svg',
  'citi-bulk-logo': '/images/citi-bulk-logo.svg',
  'add-icon': '/images/add-icon.svg',
  'update-icon': '/images/update-icon.svg',
  'bulk-subscription-icon': '/images/bulk-subscription-icon.svg',
  // 'excel-icon': '/images/excel-icon.svg',
  'check-sub': '/images/check-sub.svg',
  'error-yellow': '/images/error-yellow.svg',
  'warning-octagon': '/images/warning-octagon.svg',

  'users-icon': '/images/users-icon.svg',
  'citi-users-icon': '/images/citi-users-icon.svg',

  'admin-user-icon': '/images/admin-user.svg',

  'locked-icon': '/images/locked-icon.svg',
  'citi-locked-icon': '/images/citi-locked-icon.svg',

  'locked-icon-grey': '/images/locked-icon-grey.svg',

  'logout-icon': '/images/logout-icon.svg',
  'citi-logout-icon': '/images/citi-logout-icon.svg',

  'plans-icon': '/images/plans-icon.svg',
  'checkout-preview': '/images/checkout-preview.svg',

  'today-Cards-graph': '/images/today-Cards-graph.svg',
  'calendar-icon': '/images/calendar-icon.svg',
  'help-icon-colored': '/images/help-icon-colored.svg',

  'active-subscription-icon': '/images/active-subscription-icon.svg',

  'pause-icon': '/images/pause-icon.svg',

  'credit-card': '/images/credit-card.svg',

  'plus-icon': '/images/plus-icon.svg',

  'master-card': '/images/Mastercard_recently_used.svg',

  'master-card-icon': '/images/Mastercard-icon.svg',

  plural_logo: '/images/plural_logo.svg',

  'pci-icon': '/images/pci-icon.svg',

  'pci-updated-icon': '/images/updated-pci-icon.svg',

  'safekey-icon': '/images/safekey-icon.svg',

  'visa-icon': '/images/visa-icon.svg',
  'visa-logo': '/images/visa-logo.svg',
  'rupay-logo': '/images/rupay.svg',
  'mastercard-logo': '/images/mastercard.svg',
  'maestro-logo': '/images/Maestro.svg',
  'amex-logo': '/images/amex.svg',
  'diners-logo': '/images/dinersClub.svg',
  'axis-logo': '/images/axisBank.svg',
  'hsbc-logo': '/images/hsbcBank.svg',
  lenderKotak: '/images/lenders/lender-kotak.svg',
  lenderAnnapurna: '/images/lenders/lender-annapurna-412c99.png',
  lenderMahindra: '/images/lenders/lender-mahindra-2b43c3.png',
  lenderDmi: '/images/lenders/lender-dmi.svg',
  lenderJupiter: '/images/lenders/lender-jupiter.svg',
  lenderIdfcBank: '/images/lenders/lender-idfc-bank.svg',
  lenderAvanse: '/images/lenders/lender-avanse.svg',
  lenderTvsCredit: '/images/lenders/lender-tvs-credit.svg',
  lenderMihuru: '/images/lenders/lender-mihuru.svg',

  'collapse-logo': '/images/collapse-logo.svg',

  'doc-icon': '/images/doc-icon.svg',

  'payouts-icon': '/images/payouts-icon.svg',

  'calendarBlank-icon': '/images/calendarBlank-icon.svg',

  'smart-routing': '/images/smart-routing.svg',

  offers: '/images/offers.svg',

  'offers-icon-white': '/images/offers-icon-white.svg',

  'api-documentation-icon': '/images/api-documentation-icon.svg',

  'payment-link-icon': '/images/payment-link-icon.svg',

  'payment-page-icon': '/images/payment-page-icon.svg',

  'analytic-icon': '/images/analytic-icon.svg',

  'setting-icon': '/images/setting-icon.svg',

  'union-down': '/images/union-down.svg',

  'union-up': '/images/union-up.svg',

  ArrowsCounterClockwise: '/images/ArrowsCounterClockwise.svg',

  CreditCard: '/images/CreditCard.svg',

  'CreditCard-icon': '/images/CreditCard-icon.svg',

  'debitCard-icon': '/images/debitCard-icon.svg',

  'upi-icon': '/images/upi-icon.svg',

  'upi-icon-2': '/images/upi-icon-2.svg',

  'wallet-icon': '/images/wallet-icon.svg',

  'other-icon': '/images/other-icon.svg',
  bullet1: '/images/bullet1.svg',
  bullet2: '/images/bullet2.svg',

  'desktop-icon': '/images/desktop-icon.svg',

  'mobile-icon': '/images/mobile-icon.svg',
  'success-transactions-bullet': '/images/success-transactions-bullet.svg',

  'failed-transactions-bullet': '/images/failed-transactions-bullet.svg',

  'caret-down': '/images/caret-down.svg',

  'caret-up': '/images/caret-up.svg',

  'bell-icon': '/images/bell-icon.svg',

  'dropdown-icon': '/images/dropdown-icon.svg',

  'notification-icon': '/images/notification-icon.svg',

  'alert-icon': '/images/alert-icon.svg',

  'payByPoints-icon': '/images/payByPoints-icon.svg',

  'bankTransfer-icon': '/images/bank-transfer.svg',

  'emi-icon': '/images/emi-icon.svg',

  'net-banking-icon': '/images/net-banking-icon.svg',

  'net-banking-icon-2': '/images/net-banking-icon-2.svg',

  'buy-now-pay-later-icon': '/images/buy-now-pay-later-icon.svg',

  'payments-icon-white': '/images/payments-icon-white.svg',

  'citi-payments-icon-white': '/images/citi-payments-icon-white.svg',

  'grey-calendar-icon': '/images/grey-calendar-icon.svg',

  'white-dropdown': './images/white-dropdown.svg',

  'white-payment-links': '/images/white-payment-links.svg',

  'citi-white-payment-links': '/images/citi-white-payment-links.svg',

  'refunds-icon-white': '/images/refunds-icon-white.svg',

  'citi-refunds-icon-white': '/images/citi-refunds-icon-white.svg',

  'smartRouting-icon-white': '/images/smartRouting-icon-white.svg',

  'payment-pages-white-icon': '/images/payment-pages-white-icon.svg',

  'analytics-icon-white': '/images/analytics-icon-white.svg',

  'citi-analytics-icon-white': '/images/citi-analytics-icon-white.svg',

  'settings-icon-white': '/images/settings-icon-white.svg',

  'citi-settings-icon-white': '/images/citi-settings-icon-white.svg',

  'overview-dropdown-blue': '/images/overview-dropdown-blue.svg',

  'overview-dropdown-gray': '/images/overview-dropdown-gray.svg',

  'error-background': '/images/error-background.svg',

  'square-four': '/images/square-four.svg',

  'overview-white-icon': '/images/overview-white-icon.svg',

  'citi-overview-white-icon': '/images/citi-overview-white-icon.svg',

  'payment-links-white-icon': '/images/payment-links-white-icon.svg',

  'back-arrow-blue': '/images/back-arrow-blue.svg',

  'citi-back': '/images/down.svg',

  'vectoe-img1': '/images/vectoe-img1.svg',

  'vectoe-img2': '/images/vectoe-img2.svg',

  'vectoe-img3': '/images/vectoe-img3.svg',

  'vectoe-img4': '/images/vectoe-img4.svg',

  'login-bg': '/images/login-bg.svg',

  'citi-login-bg': '/images/citi-login-bg.svg',

  'trm-icon': '/images/trm-icon.svg',

  'megaphone-icon': '/images/Megaphone.svg',
  'responsive-not-available-icon': '/images/responsive-not-available-icon.svg',
  'alert-rounded': '/images/alert-rounded.svg',
  'alert-red': '/images/alert-red.svg',
  'green-double-tick': '/images/green-double-tick.svg',
  'cross-circle': '/images/cross-circle.svg',
  'copy-icon': '/images/copy-icon.svg',
  'citi-copy-icon': '/images/citi-copy-icon.svg',
  'copy-icon-disputes': '/images/copy-icon-disputes.svg',
  
  // Dispute status icons
  'win-icon': '/images/win-icon.svg',
  'loss-icon': '/images/loss-icon.svg',
  'review-icon': '/images/review-icon.svg',
  'pending-action-icon': '/images/pending-action-icon.svg',
  'dropdown-arrow-icon': '/images/dropdown-arrow-icon.svg',
  'disputes-subheader': '/images/disputes-subheader.svg',
  'partially-defend-icon': '/images/partially-defend-icon.svg',
  'defend-icon': '/images/defend-icon.svg',
  'accept-icon': '/images/accept-icon.svg',
  'individual-payouts-icon': '/images/individual-payouts-icon.svg',
  'bulk-payouts-icon': '/images/bulk-payouts-icon.svg',
  'payout-links-icon': '/images/payout-links-icon.svg',
  'beneficiaries-icon': '/images/beneficiaries-icon.svg',
  'faq-icon': '/images/faq-icon.svg',
  'account-balance-icon': '/images/account-balance-icon.svg',
  'grey-refresh-icon': '/images/grey-refresh-icon.svg',
  'payout-plus': '/images/payout-plus.svg',
  'payout-equals': '/images/payout-equals.svg',
  'payout-minus': '/images/payout-minus.svg',
  'beneficiaries-subheader': '/images/beneficiaries-subheader.svg',
  'payout-link-subheader': '/images/payout-link-subheader.svg',
  'bulk-payout-subheader': '/images/bulk-payout-subheader.svg',
  'individual-payout-subheader': '/images/individual-payout-subheader.svg',
  'payouts-subheader': '/images/payouts-subheader.svg',
  'settlements-subheader': '/images/settlementsIconSubHeader.svg',
  'commissions-subheader': '/images/commissions-subheader.svg',
  'citi-settlements-icon': '/images/citi-settlements-icon.svg',
  'citi-disputes-icon': '/images/citi-disputes-icon.svg',
  'settlements-overview-icon': '/images/settlements-overview-icon.svg',
  'shield-check': '/images/shield-check.svg',
  'shield-slash': '/images/shield-slash.svg',
  'close-modal-circle': '/images/close-modal-circle.svg',
  'edit-icon-blue': '/images/edit-icon-blue.svg',
  'ppe-info-icon': '/images/PPE-info-icon.svg',
  'console-logo': '/images/console-logo.svg',
  'gateway-logo': '/images/gateway-logo.svg',
  'chevron-down': '/images/chevron-down.svg',
  'home-icon': '/images/home-icon.svg',
  'check-icon': '/images/check-icon.svg',
  'citi-check-icon': '/images/citi-check-icon.svg',

  'check-ODS': '/images/check-ODS.svg',
  'payout-icon': '/images/payout-icon.svg',
  'plural-icon': '/images/plural-icon.svg',

  'unified-arrow-down': '/images/unified-arrow-down.svg',
  'unified-gateway-icon': '/images/unified-gateway-icon.svg',
  'partner-default-dashboard-logo': '/images/partner-default-dashboard-logo.svg',
  'unified-gateway-text': '/images/unified-gateway-text.svg',
  'citi-unified-gateway-icon': '/images/citi-unified-gateway-icon.svg',
  'citi-unified-gateway-text': '/images/citi-unified-gateway-text.svg',
  'unified-payout-icon': '/images/unified-payout-icon.svg',
  'unified-subscription-icon': '/images/unified-subscription-icon.svg',
  'unified-payout-text': '/images/unified-payout-text.svg',
  'unified-router-icon': '/images/unified-router-icon.svg',
  'unified-router-text': '/images/unified-router-text.svg',
  check: '/images/check.svg',
  'unified-arrow-circle-right': '/images/unified-arrow-circle-right.svg',
  'about-color': '/images/about-color.svg',
  'citi-about-color': '/images/citi-about-color.svg',
  'pinelabs-text': '/images/pinelabs-text.svg',
  'information-icon': '/images/information-icon.svg',
  'information-icon-yellow': '/images/information-icon-yellow.svg',
  'information-icon-purple': '/images/information-icon-purple.svg',
  'backinfo-arrow': '/images/ArrowCircleUpRight.svg',
  'document-icon': '/images/document-icon.svg',
  'information-arrow': '/images/information-arrow.svg',
  'help-circle': '/images/help-circle.svg',
  'happy-news': '/images/happyNews.svg',
  'happy-news-new': '/images/happy-news-new.svg',
  'tour-downloadMPR': '/images/tour-download-MPR.png',
  'citi-tour-download-MPR': '/images/citi-tour-download-MPR.png',
  'tour-switchProducts': '/images/tour-switch-Products.png',
  'pacb-tour-1': '/images/Payments Landing - Coach mark-1.png',
  'pacb-tour-2': '/images/Payments Landing - Coach mark-2.png',
  'pacb-tour-3': '/images/Payments Landing - Coach mark-3.png',
  'tour-userManagement-gif': '/images/tour-userManagement-gif.gif',
  'citi-tour-user-management-gif': '/images/citi-tour-user-management-gif.gif',
  'play-circle': '/images/play-circle.svg',
  'white-arrow-down': '/images/whiteDropdown.png',
  'citi-logo': '/images/citi-logo.svg',
  'powered-by-plural': '/images/powered-by-plural.svg',
  'plural-logo-citi': '/images/plural.svg',
  'set-password-link-expired': '/images/set-password-link-expired.png',
  'credit-card-logo': '/images/credit-card-logo.svg',
  'pay4-icon': '/images/pay4-icon.svg',
  'information-icon-imei': '/images/information-icon-imei.svg',
  'info-icon-warning': '/images/info-icon-warning.svg',
  'info-icon-light': '/images/infoIcon.svg',
  'green-timeline': '/images/greenTimeline.svg',
  'grey-timeline': '/images/greyTimeline.svg',
  'green-checked': '/images/checked-green.svg',
  'chevron-down-black': '/images/chevron-down-black.svg',
  'partner-summary': '/images/partner-summary.svg',
  'partner-all-merchants': '/images/partner-all-merchants.svg',
  'partner-settings': '/images/partner-settings.svg',
  'partner-reports': '/images/partner-reports.svg',
  'partner-reports-light': '/images/partner-reports-light.svg',
  'partner-commissions': '/images/partner-commissions.svg',
  'action-arrow': '/images/action-arrow.svg',
  'all-transactions': '/images/all-transactions.svg',
  'citi-all-transactions': '/images/citi-all-transactions.svg',
  'partner-transactions': '/images/partner-transactions.svg',
  'partner-merchants': '/images/partner-merchants.svg',
  'all-merchants': '/images/all-merchants.svg',
  'citi-all-merchants': '/images/citi-all-merchants.svg',
  'partner-refund': '/images/partner-refunds.svg',
  'partner-settlement': '/images/partner-settlements.svg',
  'partner-payment': '/images/partner-transactions.svg',
  'partner-payment links': '/images/payment-link-icon.svg',
  'partner-generate': '/images/partner-generate.svg',
  'citi-generate': '/images/citi-partner-generate.svg',
  'all-reports': '/images/all-reports.svg',
  'citi-reports': '/images/citi-reports-white-icon.svg',
  store: '/images/Store.svg',
  'partner-logo': '/images/pine-labs-partner.svg',
  'reports-icon-white': '/images/reports-icon-white.svg',
  'payments-icon-black': '/images/partner-transactions.svg',
  'refunds-icon-black': '/images/refunds-icon-black.svg',
  'settlements-icon-black': '/images/settlements-icon-black.svg',
  'mpr-icon-black': '/images/mpr-icon-black.svg',
  'payment-links-icon-black': '/images/payment-links-icon-black.svg',
  'generate-icon': '/images/generate-icon.svg',
  'split-logo': '/images/branching-path-up.svg',
  'citi-split-logo': '/images/citi-branching-path-up.svg',
  'circular-tick-icon': '/images/circular-tick-icon.svg',
  'more-link-icon': '/images/more-link.svg',
  'green-tick': '/images/green-tick.svg',
  'partial-refund': '/images/partial-refund.svg',
  'pending-clock': '/images/pending-clock.svg',
  'upi-logo': '/images/upi-logo.svg',
  'setting-tool-logo': '/images/setting-tool-logo.svg',
  'status-active': '/images/status-active.svg',
  'profile-submition': '/images/profile-submition.svg',
  'email-expired': '/images/Email-Verification-Expired.svg',
  'email-verified': '/images/Email-Verified.svg',
  'white-tick': '/images/white-tick.svg',
  'access-code-icon': '/images/code.svg',
  'capture-pan-icon': '/images/pan.svg',
  'selfie-icon': '/images/selfie.svg',
  'verification-icon': '/images/verify.svg',
  'check-kyc-icon': '/images/check-kyc.svg',
  'exclamation-icon': '/images/Exclamation.svg',
  'edit-frame': '/images/Edit-Frame.svg',
  checkgroup: '/images/check-group.svg',
  'video-kyc-progress': '/images/video-kyc-progress.svg',
  'pan-svg': '/images/pan-svg.svg',
  'retry-kyc': '/images/retrykyc.svg',
  'info-yellow': '/images/info-yellow.svg',
  'arrow-right-ss': '/images/arrowrightss.svg',
  'arrow-left-ss': '/images/arowleftss.svg',
  'merchant-sidebar-logo': '/images/merchant-sidebar-logo.svg',
  'transaction-icon': '/images/transaction-card-icon.svg',
  'save&go': '/images/save&goArrow.svg',
  'product-listing-icon': '/images/productListingtick.svg',
  'digilocker': '/images/digilocker.svg',
  'bulb': '/images/bulb.svg',
  'bpcl-envelope-open': '/images/bpcl-envelope-open.svg',
  'grey-circle-tick': '/images/grey_circle_tick.svg',
  'bulk-upload': '/images/bulk-upload.svg',
  'upload-icon': '/images/upload-icon.svg',
  'excel-icon': '/images/excel-icon.svg',
  'cross-modal-dark': '/images/cross-modal-dark.svg',
  'uploaded': '/images/uploaded.svg',
  'error-upload': '/images/error-upload.svg',
  'upload-history': '/images/upload-history.svg',
  'payment-link-success': '/images/paymentlinksuccess.svg',
  'delete-icon': '/images/delete-udf.svg',
  'firc-icon-black':'/images/globe.svg',

  // CHECKOUT INSIGHTS ICONS
  'checkout-insight-icon': '/images/checkout-insight-icon.svg',
  'checkout-insight-icon-dark': '/images/checkout-insight-icon-dark.svg',
  'payment-method-emi': '/images/payment-modes/payment-method-emi.svg',
  'payment-method-credit-emi': '/images/payment-modes/payment-method-credit-emi.svg',
  'payment-method-debit-emi': '/images/payment-modes/payment-method-debit-emi.svg',
  'payment-method-card': '/images/payment-modes/payment-method-card.svg',
  'payment-method-netbanking': '/images/payment-modes/payment-method-netbanking.svg',
  'payment-method-upi': '/images/payment-modes/payment-method-upi.svg',
  'payment-method-wallet': '/images/payment-modes/payment-method-wallet.svg',
  'issuer-hdfc': '/images/issuers/hdfc.svg',
  'issuer-sbi': '/images/issuers/sbi.svg',
  'issuer-icici': '/images/issuers/icici.svg',

  // white labelling

  'plural-online': '/images/plural-online.svg',
  'pinelabs-online': '/images/pinelabs-online.svg',
  'powered-pinelabs-online': '/images/powered-pinelabs-online.svg',
  'document-citi-icon': '/images/document-citi-icon.svg',
  'new-signup': '/images/new-signup.svg',
  'eye-open': '/images/fi-sr-eye.svg',
  'eye-closed': '/images/fi-sr-eye-crossed.svg',
  'money-icon': '/images/banknotepayout.svg',
  'lightning-icon': '/images/lightning-bolt.svg',
  '4offers': '/images/4offers.svg',
  'offers-checkout': '/images/offers-checkout.svg',
  'checkout-bnpl': '/images/checkout-bnpl.svg',
  'checkout-cards': '/images/checkout-cards.svg',
  'checkout-emi-payment': '/images/checkout-emi-payment.svg',
  'checkout-netbanking': '/images/checkout-netbanking.svg',
  'checkout-upi': '/images/checkout-upi.svg',
  'checkout-wallet': '/images/checkout-wallet.svg',
  'checkout-arrow-right': '/images/checkout-arrow-right.svg',
  'checkout-arrow-down': '/images/checkout-arrow-down.svg',
  'checkout-card-details': '/images/checkout-card-details.svg',
  'checkout-back': '/images/checkout-back.svg',
  'checkout-pinelabs-online': '/images/checkout-pinelabs-online.svg',
  'updated-pci-icon-v3': '/images/updated-pci-icon-v3.svg',
  'cross-button-dark': '/images/cross-button-dark.svg',
  'bpcl-tick': '/images/bpcl-tick.svg',
  'bpcl-exclamation': '/images/bpcl-exclamation.svg',
  'red-exclamation': '/images/red-exclamation.svg',
  'upload-documents': '/images/upload-documents.svg',
  'upload-bpcl': '/images/upload-bpcl.svg',
  'bpcl-mail': '/images/bpcl-mail.svg',
  'bpcl-caution': '/images/bpcl-caution.svg',
  'bpcl-pending': '/images/bpcl_pending.svg',
  'bpcl-done': '/images/bpcl-done.svg',
  'verified-business-icon': '/images/verify-business.svg',
  'round-caution-grey': '/images/round-caution-grey.svg',
  'upload-bpcl-doc': '/images/upload-bpcl-doc.svg',
  'pdf-icon': '/images/pdf.svg',
  'video-icon': '/images/video.svg',
  'successfully-submitted-icon': '/images/submitted-success-icon.svg',
  'danger-icon-circular': '/images/danger-icon-circular.svg',


  // These below images are being used from API directly please do not change
  'uploaded-documents': '/images/uploaded-documents.svg',
  'website-links': '/images/website-links.svg',
  'additional-details': '/images/additional-details.svg',

  'apple-wallet': '/images/apple-wallet.svg',
  'apple-info': '/images/apple-info.svg',
  'file-pill': '/images/file-pill.svg',
  'file-close': '/images/file-close.svg',
  'file-uploader': '/images/file-uploader.svg',
  'file-check': '/images/file-check.svg',
  'brand-wallet': '/images/brand-wallet.svg',
  'wallet-offer': '/images/wallet-offer.svg',
  'add-money': '/images/add-money.svg',
  'add-gift-card': '/images/add-gift-card.svg',
  'wallet-check': '/images/wallet-check.svg',
  'wallet-upload': '/images/wallet-upload.svg',
  'wallet-excel': '/images/wallet-excel.svg',
  'wallet-file-upload-success': '/images/wallet-file-upload-success.svg',
  'wallet-file-upload-failed': '/images/wallet-file-upload-failed.svg',
  'wallet-error': '/images/wallet-error.svg',
  'file-processed': '/images/file-processed.svg',
  'flaky-icon': '/images/flaky.svg',
  'checked-vibrant': '/images/checkedVibrant.svg',
  'question-vibrant': '/images/questionVibrant.svg',
  "sample-doc-one" : '/images/invoice_bill_sample_1.png',
  "sample-doc-two" : '/images/sampleDoc2.png',
  "sample-doc-three" : '/images/sampleDoc3.png',
  "sample-doc-four" : '/images/sampleDoc4.png',
  "black-cross" : '/images/black-cross.svg',

  'ckyc-building': '/images/ckyc.svg',
  'redo-ckyc': '/images/redo-kyc.svg',
  'favicon-chat': '/images/favicon.svg',
  'bank-account-pending': '/images/bank-account-pending.svg',
  'bank-account-rejected': '/images/bank-account-reject.svg',
  'bank-account-approved': '/images/bank-account-approved.svg',
  'pinelabs-online-svg': '/images/pinelabs-online.svg',

  // Wallets
  'wallet-airtel': '/images/wallets/Airtel Money.svg',
  'wallet-amazon': '/images/wallets/Amazon Pay.svg',
  'wallet-freecharge': '/images/wallets/Freecharge.png',
  'wallet-itz': '/images/wallets/ITZ Cash Card.png',
  'wallet-jio': '/images/wallets/Jio Money.svg',
  'wallet-mobikwik': '/images/wallets/Mobikwik.svg',
  'wallet-ola': '/images/wallets/OLA money.png',
  'wallet-oxigen': '/images/wallets/Oxigen.svg',
  'wallet-paytm': '/images/wallets/PayTm.svg',
  'wallet-payzapp': '/images/wallets/PAYZAPP.png',
  'wallet-phonepe': '/images/wallets/PhonePe.svg',
  'wallet-yesbank': '/images/wallets/Yes Bank Wallet.svg',
  'wallet-google': '/images/wallets/googlePay.svg',
  'initiated-payment-timeline': '/images/initiated-payment.svg',
  'failed-payment-timeline': '/images/failed-payment.svg',
  'content-copy' : '/images/content_copy.svg',

  // new self serve

  "state-default": "/images/StateDefault.svg",
  "state-warning": "/images/StateWarning.svg",
  "state-error": "/images/StateError.svg",
  "wrench-black": "/images/wrench-black.svg",

  // GET STARTED component
  'get-started-circle-live-1': '/images/get-started/circle-live-1.svg',
  'get-started-circle-live-2': '/images/get-started/circle-live-2.svg',
  'get-started-chart-bg': '/images/get-started/chart-bg.svg',
  'get-started-chart-glass': '/images/get-started/chart-illustration.svg',
  'get-started-chart-line-1': '/images/get-started/chart-line-1.svg',
  'get-started-chart-line-2': '/images/get-started/chart-line-2.svg',
  'get-started-circle-docs-1': '/images/get-started/circle-docs-1.svg',
  'get-started-circle-docs-2': '/images/get-started/circle-docs-2.svg',
  'get-started-document-illustration': '/images/get-started/doc-new-illustration-1.svg',
  'get-started-document-icon': '/images/get-started/document-icon.svg',
  'get-started-arrow-up-right': '/images/get-started/arrow-up-right.svg',


  // product tour 
  'user-management-tour-img': '/images/user-management-tour.svg',
  'settlements-tour-img': '/images/settlements-tour.svg',
  'dropdown-tour-img': '/images/dropdown-tour.svg',

  // GET STARTED - Payment Link
  'get-started-payment-link':'/images/get-started/payment-link-get-started-1.svg',
  'docs-get-started': '/images/get-started/Chart.svg',
  
  //  video kyc screen new icons 

  'video-kyc-frame': '/images/video-kyc-Frame-icon.svg',
  'video-kyc-pan': '/images/video-kyc-pan.svg',
  'video-kyc-wifi': '/images/video-kyc-Wifi-icon.svg',
  'assisted-vkyc-banner': '/images/assisted-vkyc/assisted-vkyc-banner1.svg',
  'assisted-vkyc-reminder': '/images/assisted-vkyc/assisted-vkyv-reminder1.svg',
  'assisted-vkyc-eye-open': '/images/assisted-vkyc/eye-open1.svg',
  'assisted-vkyc-eye-closed': '/images/assisted-vkyc/eye-closed1.svg',
  'assisted-vkyc-arrow-right': '/images/assisted-vkyc/ArrowRight.svg',
  'assisted-vkyc-close': '/images/assisted-vkyc/Button.svg',
  'assisted-vkyc-edit': '/images/assisted-vkyc/edit-vkyc-details1.svg',
  'assisted-vkyc-laptop': '/images/assisted-vkyc/laptop1.svg',
  'split-settlement-arrows': '/images/split-settlement-arrows.svg',
  'split-settlement-prohibit': '/images/split-settlement-prohibit.svg',
  'split-settlement-prohibit-modal': '/images/split-settlement-prohibit-modal.svg',
  'split-settlement-history': '/images/split-settlement-history.svg',

  //chatbot icons
  'model-avatar': '/images/model-avatar.svg',
  'chat-ticket': '/images/chat-ticket.svg',
  'chat-minimize': '/images/chat-minimize.svg',
  'guide-logo': '/images/Guidelogo.svg',
  'guide-mini-logo': '/images/GuideMinilogo.svg',
};
